import mastersActionTypes from '../../../constants/actions/masters/masters'

export function fetchProcessingAgencyCommunicationServices () {
  return {
    type: mastersActionTypes.FETCH_PROCESSING_AGENCY_COMMUNICATION_SERVICES
  }
}
